import React from 'react';
import { Button, Checkbox, Form, Message } from 'semantic-ui-react';
import { defaultsV96, priceRowsV96 } from './upscalingConfigV96';
import './upscalingV96.css';

export default function ImageUpscalingV96({
  type,
  models,
  config,
  onChange,
  t,
}) {
  const up = { ...defaultsV96, ...config.upscaling_v96 };
  const label = (key) => t(`upscaling_v96.${key}`);
  const supported = [1, 3, 40, 50].includes(Number(type));
  const change = (values) =>
    onChange(null, {
      name: 'upscaling_v96',
      value: { ...up, ...values },
    });
  const rows = priceRowsV96(up);
  const setRow = (index, values) =>
    change({
      price_rows: rows.map((row, i) =>
        i === index ? { ...row, ...values } : row
      ),
    });
  const masked = (config.masked_secret_fields_v815 || []).includes(
    'upscale_api_key_v96'
  );
  return (
    <section className='upscaling-v96' aria-label={label('title')}>
      <Form.Field>
        <Checkbox
          toggle
          label={label('title')}
          checked={up.enabled}
          disabled={!supported && !up.enabled}
          onChange={(_, { checked }) => change({ enabled: checked })}
        />
      </Form.Field>
      {up.enabled && (
        <>
          {!supported && <Message warning content={label('unsupported')} />}
          <Form.Dropdown
            fluid
            multiple
            search
            selection
            label={label('models')}
            aria-label={label('models')}
            options={[...new Set([...models, ...up.models])].map((model) => ({
              key: model,
              value: model,
              text: model,
            }))}
            value={up.models}
            onChange={(_, { value }) => change({ models: value })}
          />
          <Form.Input
            label={label('endpoint')}
            value={up.endpoint}
            placeholder='https://gpu.example/v1/upscale'
            onChange={(_, { value }) => change({ endpoint: value })}
          />
          <Form.Input
            type='password'
            autoComplete='new-password'
            label={label('key')}
            placeholder={masked ? label('saved_key') : ''}
            value={config.upscale_api_key_v96 || ''}
            onChange={(_, { value }) =>
              onChange(null, { name: 'upscale_api_key_v96', value })
            }
          />
          <div className='upscaling-v96-grid'>
            <Form.Input
              label={label('model')}
              value={up.model}
              onChange={(_, { value }) => change({ model: value })}
            />
            <Form.Input
              label={label('source')}
              value={up.source_size}
              placeholder='1024x1024'
              onChange={(_, { value }) => change({ source_size: value })}
            />
            <Form.Dropdown
              fluid
              selection
              label={label('transport')}
              value={up.transport}
              options={['base64', 'url'].map((value) => ({
                key: value,
                value,
                text: value === 'base64' ? 'Base64' : 'URL / Base64',
              }))}
              onChange={(_, { value }) => change({ transport: value })}
            />
            <Form.Input
              type='number'
              min={5}
              max={300}
              step={1}
              label={label('timeout')}
              value={up.timeout_seconds}
              onChange={(_, { value }) => change({ timeout_seconds: value })}
            />
          </div>
          <Form.Dropdown
            fluid
            selection
            label={label('failure')}
            value={up.failure_mode}
            options={['required', 'best_effort'].map((value) => ({
              key: value,
              value,
              text: label(value),
            }))}
            onChange={(_, { value }) => change({ failure_mode: value })}
          />
          <div className='upscaling-v96-prices'>
            {rows.map((row, index) => (
              <div className='upscaling-v96-price' key={index}>
                <Form.Input
                  label={label('target')}
                  placeholder='4K / 8K / 3840x2160'
                  value={row.target}
                  onChange={(_, { value }) => setRow(index, { target: value })}
                />
                <Form.Input
                  label={label('price')}
                  inputMode='decimal'
                  value={row.usd}
                  onChange={(_, { value }) => setRow(index, { usd: value })}
                />
                <Button
                  type='button'
                  icon='trash'
                  basic
                  title={label('remove')}
                  aria-label={label('remove')}
                  onClick={() =>
                    change({ price_rows: rows.filter((_, i) => i !== index) })
                  }
                />
              </div>
            ))}
            <Button
              type='button'
              icon='plus'
              basic
              title={label('add')}
              aria-label={label('add')}
              disabled={rows.length >= 32}
              onClick={() =>
                change({ price_rows: [...rows, { target: '', usd: '' }] })
              }
            />
          </div>
        </>
      )}
    </section>
  );
}
